"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[842],{

/***/ 4995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ FhhBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var next_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fabric_ds_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);






var _getConfig = next_config_js__WEBPACK_IMPORTED_MODULE_1___default()(),
    contextPath = _getConfig.publicRuntimeConfig.contextPath;

var FhhBreadcrumbs = function FhhBreadcrumbs(_ref) {
  var className = _ref.className,
      isPreview = _ref.isPreview;

  var previewOnClick = function previewOnClick(e) {
    e.preventDefault();
    alert('Knapper og lenker er skrudd av under forhåndsvisning');
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_fabric_ds_react__WEBPACK_IMPORTED_MODULE_2__/* .Breadcrumbs */ .Oo, {
    className: "mb-16 ".concat(className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
      href: isPreview ? '#' : '/reise/',
      onClick: isPreview ? function () {
        return previewOnClick;
      } : undefined,
      "data-testid": "vertical",
      children: "Reise"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
      href: isPreview ? '#' : "".concat(contextPath, "/resultat/"),
      onClick: isPreview ? function () {
        return previewOnClick;
      } : undefined,
      "data-testid": "submarket",
      children: ["Feriehus ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        className: "hidden sm:inline",
        children: "og hytter til leie"
      })]
    })]
  });
};

/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ lazyLoad; }
/* harmony export */ });
/* harmony import */ var _finn_no_inscreen_observer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(536);

var lazyLoad = function lazyLoad(elements, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    once: true
  };
  var observer = new _finn_no_inscreen_observer__WEBPACK_IMPORTED_MODULE_0__["default"](callback, options);

  for (var i = 0, len = elements.length; i < len; i++) {
    if (elements[i] !== null && elements[i] !== undefined) {
      elements[i].innerHTML = '';
      observer.observe(elements[i]);
    }
  }
};

/***/ }),

/***/ 5151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ez": function() { return /* binding */ trackConfirmOrder; },
/* harmony export */   "NV": function() { return /* binding */ trackCheckPriceAndAvailability; },
/* harmony export */   "Z0": function() { return /* binding */ trackPageView; },
/* harmony export */   "bi": function() { return /* binding */ trackResultPage; },
/* harmony export */   "eF": function() { return /* binding */ trackSendMessage; },
/* harmony export */   "ob": function() { return /* binding */ trackClick; },
/* harmony export */   "yN": function() { return /* binding */ trackAddBookingToCalendar; }
/* harmony export */ });
/* harmony import */ var _home_travis_build_finn_travel_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _finn_no_pulse_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6562);
/* harmony import */ var _finn_no_pulse_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_finn_no_pulse_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_util_datetime_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3979);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_finn_travel_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var extractNumberOfBeedrooms = function extractNumberOfBeedrooms(objectData) {
  return (// blank string, NaN or 0 should return null
    Number(objectData === null || objectData === void 0 ? void 0 : objectData.noOfBedrooms) || undefined
  );
};

var calculateAverageWeeklyPrice = function calculateAverageWeeklyPrice(objectData) {
  var _objectData$pricing, _objectData$pricing2, _objectData$pricing2$, _objectData$pricing3, _objectData$pricing3$;

  var currency = objectData === null || objectData === void 0 ? void 0 : (_objectData$pricing = objectData.pricing) === null || _objectData$pricing === void 0 ? void 0 : _objectData$pricing.currency;
  var from = objectData === null || objectData === void 0 ? void 0 : (_objectData$pricing2 = objectData.pricing) === null || _objectData$pricing2 === void 0 ? void 0 : (_objectData$pricing2$ = _objectData$pricing2.week) === null || _objectData$pricing2$ === void 0 ? void 0 : _objectData$pricing2$.from;
  var to = objectData === null || objectData === void 0 ? void 0 : (_objectData$pricing3 = objectData.pricing) === null || _objectData$pricing3 === void 0 ? void 0 : (_objectData$pricing3$ = _objectData$pricing3.week) === null || _objectData$pricing3$ === void 0 ? void 0 : _objectData$pricing3$.to;

  if (currency === 'NOK' && Number.isInteger(from) && Number.isInteger(to)) {
    // Should only track whole numbers
    return Math.round((from + to) / 2);
  } else {
    return undefined;
  }
};

var trackCommonClick = function trackCommonClick(_ref) {
  var _objectData$adId, _objectData$location$, _objectData$location, _objectData$location$2, _objectData$location2, _safeParseISO$toISOSt, _safeParseISO, _safeParseISO$toISOSt2, _safeParseISO2, _objectData$organisat, _objectData$organisat2;

  var intent = _ref.intent,
      name = _ref.name,
      objectName = _ref.objectName,
      objectData = _ref.objectData,
      targetData = _ref.targetData,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      numberOfAdults = _ref.numberOfAdults,
      numberOfChildren = _ref.numberOfChildren,
      numberOfInfants = _ref.numberOfInfants;
  return (0,_finn_no_pulse_sdk__WEBPACK_IMPORTED_MODULE_1__.trackEvent)({
    type: 'Click',
    intent: intent,
    name: name,
    object: {
      id: name.replaceAll(' ', '_').toLowerCase(),
      type: 'UIElement',
      elementType: 'Button',
      name: objectName !== null && objectName !== void 0 ? objectName : undefined,
      hasExtendedProfile: false,
      items: [{
        // TODO Should all these have pagetype ClassifiedAd?
        type: 'ClassifiedAd',
        id: objectData === null || objectData === void 0 ? void 0 : objectData.adId,
        contentId: objectData === null || objectData === void 0 ? void 0 : (_objectData$adId = objectData.adId) === null || _objectData$adId === void 0 ? void 0 : _objectData$adId.toString(),
        name: objectData === null || objectData === void 0 ? void 0 : objectData.heading,
        category: 'travel > holiday rental'
      }, {
        type: 'Travel',
        id: 'finntravel',
        travelType: 'holiday_rental',
        // Due to legacy definitions in Pulse, `destination` is used instead of `arrivalCountry`
        destination: (_objectData$location$ = objectData === null || objectData === void 0 ? void 0 : (_objectData$location = objectData.location) === null || _objectData$location === void 0 ? void 0 : _objectData$location.country) !== null && _objectData$location$ !== void 0 ? _objectData$location$ : undefined,
        arrivalCity: (_objectData$location$2 = objectData === null || objectData === void 0 ? void 0 : (_objectData$location2 = objectData.location) === null || _objectData$location2 === void 0 ? void 0 : _objectData$location2.locality) !== null && _objectData$location$2 !== void 0 ? _objectData$location$2 : undefined,
        // TODO skj better to get a regular date as input instead of a string
        departureDate: (_safeParseISO$toISOSt = (_safeParseISO = (0,shared_util_datetime_fns__WEBPACK_IMPORTED_MODULE_2__/* .safeParseISO */ .G3)(fromDate)) === null || _safeParseISO === void 0 ? void 0 : _safeParseISO.toISOString()) !== null && _safeParseISO$toISOSt !== void 0 ? _safeParseISO$toISOSt : undefined,
        returnDate: (_safeParseISO$toISOSt2 = (_safeParseISO2 = (0,shared_util_datetime_fns__WEBPACK_IMPORTED_MODULE_2__/* .safeParseISO */ .G3)(toDate)) === null || _safeParseISO2 === void 0 ? void 0 : _safeParseISO2.toISOString()) !== null && _safeParseISO$toISOSt2 !== void 0 ? _safeParseISO$toISOSt2 : undefined,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        numberOfInfants: numberOfInfants,
        numberOfRooms: extractNumberOfBeedrooms(objectData),
        totalPrice: calculateAverageWeeklyPrice(objectData),
        provider: (_objectData$organisat = objectData === null || objectData === void 0 ? void 0 : (_objectData$organisat2 = objectData.organisation) === null || _objectData$organisat2 === void 0 ? void 0 : _objectData$organisat2.name) !== null && _objectData$organisat !== void 0 ? _objectData$organisat : undefined
      }]
    },
    target: targetData,
    vertical: {
      name: 'travel',
      subVertical: 'holiday_rental'
    }
  });
};

var trackPageView = function trackPageView(data) {
  return (0,_finn_no_pulse_sdk__WEBPACK_IMPORTED_MODULE_1__.trackPageView)({
    object: _objectSpread({
      category: 'travel > holiday rental'
    }, data),
    vertical: {
      name: 'travel',
      subVertical: 'holiday_rental'
    }
  });
};
var trackResultPage = function trackResultPage(layout, props) {
  var _window, _filters$sorting, _data$stats$numResult, _data$stats, _data$stats$currentPa, _data$stats2;

  var data = props.data,
      filters = props.filters;

  var extractSelectionFilterList = function extractSelectionFilterList(name, emptyOrStringOrList) {
    if (typeof emptyOrStringOrList == 'string') {
      return [{
        name: name,
        value: emptyOrStringOrList
      }];
    } else if (Array.isArray(emptyOrStringOrList)) {
      return emptyOrStringOrList.map(function (propertyType) {
        return {
          name: name,
          value: propertyType
        };
      });
    } else {
      return [];
    }
  };

  var landlordTypesFor = function landlordTypesFor(isPrivate) {
    if (isPrivate === true || isPrivate === 'true') {
      return [{
        name: 'landlord_type',
        value: 'private'
      }];
    } else if (isPrivate === false || isPrivate === 'false') {
      return [{
        name: 'landlord_type',
        value: 'business'
      }];
    } else {
      return [{
        name: 'landlord_type',
        value: 'private'
      }, {
        name: 'landlord_type',
        value: 'business'
      }];
    }
  }; // TODO property type should be a name instead of a number


  var propertyTypes = extractSelectionFilterList('property_type', filters.property_types);
  var facilities = extractSelectionFilterList('facility', filters.facilities);
  var poisNearby = extractSelectionFilterList('poi_nearby', filters.pois_nearby);
  trackPageView({
    type: 'Listing',
    layout: layout,
    filters: {
      // returns undefined instead of null or empty so Pulse removes it from the event it sends
      query: new URLSearchParams((_window = window) === null || _window === void 0 ? void 0 : _window.location.search).toString() || undefined
    },
    sortingType: (_filters$sorting = filters.sorting) !== null && _filters$sorting !== void 0 ? _filters$sorting : 'best',
    // Default sorting type is 'Beste treff', i.e. 'best'
    numItems: (_data$stats$numResult = (_data$stats = data.stats) === null || _data$stats === void 0 ? void 0 : _data$stats.numResults) !== null && _data$stats$numResult !== void 0 ? _data$stats$numResult : -1,
    pageNumber: (_data$stats$currentPa = (_data$stats2 = data.stats) === null || _data$stats2 === void 0 ? void 0 : _data$stats2.currentPage) !== null && _data$stats$currentPa !== void 0 ? _data$stats$currentPa : -1,
    selectionFilters: [// TODO should any of these have a default value?
    {
      name: 'booking_from',
      value: filters.booking_from
    }, {
      name: 'booking_to',
      value: filters.booking_to
    }, {
      name: 'no_of_beds_from',
      value: filters.no_of_beds_from
    }, {
      name: 'no_of_bedrooms_from',
      value: filters.no_of_bedrooms_from
    }, {
      name: 'is_direct_booking',
      value: filters.is_direct_booking
    }, {
      name: 'price_type',
      value: filters.price_type
    }, {
      name: 'price_from',
      value: filters.price_from
    }, {
      name: 'price_to',
      value: filters.price_to
    }].concat(propertyTypes).concat(facilities).concat(poisNearby).concat(landlordTypesFor(filters.is_private)).filter(function (_ref2) {
      var value = _ref2.value;
      return value !== undefined && value !== null;
    }).map(function (_ref3) {
      var name = _ref3.name,
          value = _ref3.value;
      return {
        name: name,
        value: value.toString()
      };
    })
  });
}; // Pulse tracker id: FHH_ev04 (see tracking section in README.md)

var trackAddBookingToCalendar = function trackAddBookingToCalendar(objectData, fromDate, toDate) {
  return trackCommonClick({
    intent: 'Purchase',
    name: 'Add booking to calendar',
    objectData: objectData,
    fromDate: fromDate,
    toDate: toDate
  });
}; // Pulse tracker id: FHH_ev05 (see tracking section in README.md)

var trackConfirmOrder = function trackConfirmOrder(objectData, orderData) {
  return trackCommonClick({
    intent: 'Purchase',
    name: 'Book vacation home',
    objectData: objectData,
    fromDate: orderData === null || orderData === void 0 ? void 0 : orderData.fromDate,
    toDate: orderData === null || orderData === void 0 ? void 0 : orderData.toDate,
    numberOfAdults: orderData === null || orderData === void 0 ? void 0 : orderData.adults,
    numberOfChildren: orderData === null || orderData === void 0 ? void 0 : orderData.children,
    numberOfInfants: orderData === null || orderData === void 0 ? void 0 : orderData.infants,
    targetData: {
      type: 'Confirmation',
      id: objectData.owner.url,
      name: 'Go to confirmation page',
      referralCommission: true,
      provider: objectData.organisation.name
    }
  });
}; // Pulse tracker id: FHH_ev06 (see tracking section in README.md)

var trackSendMessage = function trackSendMessage(data) {
  return trackCommonClick(_objectSpread({
    intent: 'Send',
    name: 'Send message'
  }, data));
}; // Pulse tracker id: FHH_ev07 (see tracking section in README.md)

var trackCheckPriceAndAvailability = function trackCheckPriceAndAvailability(data) {
  var _data$objectData$isIm, _data$objectData$orga, _data$objectData$orga2;

  return trackCommonClick(_objectSpread(_objectSpread({
    intent: 'Open',
    name: 'Check price and availability',
    objectName: data.objectData.isImport ? 'import offer' : 'admin offer'
  }, data), {}, {
    targetData: {
      id: data.objectData.owner.deeplink ? data.objectData.owner.deeplink : data.objectData.owner.url,
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: (_data$objectData$isIm = data.objectData.isImport) !== null && _data$objectData$isIm !== void 0 ? _data$objectData$isIm : false,
      provider: (_data$objectData$orga = (_data$objectData$orga2 = data.objectData.organisation) === null || _data$objectData$orga2 === void 0 ? void 0 : _data$objectData$orga2.name) !== null && _data$objectData$orga !== void 0 ? _data$objectData$orga : undefined
    }
  }));
};
var trackClick = function trackClick(pulseData) {
  return (0,_finn_no_pulse_sdk__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(pulseData);
};

/***/ }),

/***/ 9866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ isPriceRange; },
/* harmony export */   "Bz": function() { return /* binding */ _formatRange; },
/* harmony export */   "dX": function() { return /* binding */ priceDescription; },
/* harmony export */   "iP": function() { return /* binding */ additionalDescription; },
/* harmony export */   "oK": function() { return /* binding */ resolveCurrencySuffix; },
/* harmony export */   "z2": function() { return /* binding */ hasPriceRangePrices; },
/* harmony export */   "zF": function() { return /* binding */ generateEntries; }
/* harmony export */ });
/* unused harmony exports _formatNumber, _formatPercent, _formatValue */
/* harmony import */ var shared_util_formatting__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6235);

var priceDescription = {
  day: 'Pris per natt',
  week: 'Pris per uke',
  weekend: 'Pris per helg',
  year: 'Tilbyr åremål/langtidsleie'
};
var additionalDescription = {
  currency: 'Pris oppgitt i',
  depositType: 'Depositum',
  cleaning: 'Rengjøringsgebyr',
  linens: 'Håndklær og sengetøy'
};
var isPriceRange = function isPriceRange(priceRange) {
  return priceRange && (Object.prototype.hasOwnProperty.call(priceRange, 'from') || Object.prototype.hasOwnProperty.call(priceRange, 'to'));
};
var hasPriceRangePrices = function hasPriceRangePrices(priceRange) {
  return Boolean((priceRange === null || priceRange === void 0 ? void 0 : priceRange.from) || (priceRange === null || priceRange === void 0 ? void 0 : priceRange.to));
};
var _formatNumber = function _formatNumber(num, currencySymbol) {
  return num ? "".concat((0,shared_util_formatting__WEBPACK_IMPORTED_MODULE_0__/* .thousandSeparated */ .IK)(num) + currencySymbol) : null;
};
var _formatPercent = function _formatPercent(num) {
  return num ? "".concat(num, "%") : null;
};
var _formatRange = function _formatRange(priceRange, currencySymbol) {
  if (priceRange.from === priceRange.to) {
    return _formatNumber(priceRange === null || priceRange === void 0 ? void 0 : priceRange.from, currencySymbol);
  }

  if (priceRange.from && priceRange.to) {
    return "fra ".concat(_formatNumber(priceRange.from, currencySymbol), " til ").concat(_formatNumber(priceRange.to, currencySymbol));
  }

  return (priceRange.from ? _formatNumber(priceRange.from, currencySymbol) : '') + (priceRange.to ? _formatNumber(priceRange.to, currencySymbol) : '');
};
var resolveCurrencySuffix = function resolveCurrencySuffix(currencyCode) {
  switch (currencyCode) {
    case 'NOK':
      return ',-';

    case 'EUR':
      return ' €';

    default:
      return ',-';
  }
};
var _formatValue = function _formatValue(value, key, pricing) {
  var _pricing$currency;

  var currencySymbol = resolveCurrencySuffix(pricing === null || pricing === void 0 ? void 0 : (_pricing$currency = pricing.currency) === null || _pricing$currency === void 0 ? void 0 : _pricing$currency.toString());

  switch (true) {
    case 'year' === key:
      return '';

    case isPriceRange(value):
      if (!hasPriceRangePrices(value)) {
        return null;
      }

      return _formatRange(value, currencySymbol);

    case 'cleaning' === key || 'linens' === key:
      return _formatNumber(Number(value), currencySymbol);

    case 'depositType' === key && 'NONE' === value:
      return null;

    case 'depositType' === key && 'REQUIRED' === value:
      return 'Ja';

    case 'depositType' === key && 'FIXED' === value:
      return _formatNumber(Number(pricing.depositAmount), currencySymbol);

    case 'depositType' === key && 'PERCENT' === value:
      return _formatPercent(Number(pricing.depositAmount));

    default:
      return value;
  }
};
var generateEntries = function generateEntries(possibleDescriptions, pricing) {
  if (pricing === undefined) {
    return [];
  }

  return Object.keys(possibleDescriptions).reduce(function (entries, key) {
    if (Object.prototype.hasOwnProperty.call(pricing, key)) {
      var pricingItemValue = pricing[key];
      var description = possibleDescriptions[key];

      var value = _formatValue(pricingItemValue, key, pricing);

      if (value) {
        entries.push({
          key: key,
          value: value,
          description: description
        });
      }
    }

    return entries;
  }, []);
};

/***/ }),

/***/ 3979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CR": function() { return /* binding */ isPast; },
/* harmony export */   "EW": function() { return /* binding */ safeDifferenceInCalendarDays; },
/* harmony export */   "G3": function() { return /* binding */ safeParseISO; },
/* harmony export */   "Y$": function() { return /* binding */ formatClientDate; },
/* harmony export */   "a$": function() { return /* binding */ formatYMDDate; },
/* harmony export */   "cz": function() { return /* binding */ formatISODate; },
/* harmony export */   "eC": function() { return /* binding */ safeParseClientDate; },
/* harmony export */   "kr": function() { return /* binding */ formatReadableDateShortNoWeekday; },
/* harmony export */   "o4": function() { return /* binding */ safeFormatClientDate; }
/* harmony export */ });
/* unused harmony exports isDate, isWithinOneYearOfToday, isNotWithinOneYearOfToday, isSameDayOrAfter, isFutureRange, travelDaysBetween, formatISODateTime, formatReadableDate, formatReadableDateShort, formatReadableDateFull, formatReadableDayTime, formatReadableTime, safeFormatISODate, safeFormatReadableDate, safeToDate, addDaysString, subDaysString, dayOfNextMonth, addDaysClient, addDaysServer */
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2890);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(805);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(813);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7679);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5277);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5209);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8746);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7561);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1182);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1011);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3767);
/*
 * IMPORTANT: We use /fp-versions of date-fns, so all arguments are in the opposite order to the standard docs.
 * See: https://date-fns.org/v2.22.1/docs/FP-Guide
 */



var isDate = function isDate(obj) {
  return obj instanceof Date === true || typeof obj === 'number';
};
var isWithinOneYearOfToday = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  start: (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Date.now()),
  end: (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(366, (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Date.now())) // leap years are cool? ¯\_(ツ)_/¯

});
var isNotWithinOneYearOfToday = function isNotWithinOneYearOfToday(date) {
  return !isWithinOneYearOfToday(date);
};
var isPast = function isPast(date) {
  return (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Date.now()));
};
var isSameDayOrAfter = function isSameDayOrAfter(other, date) {
  return isDate(other) && isDate(date) && (isSameDay(other, date) || isAfter(other, date));
};
var isFutureRange = function isFutureRange(to, from) {
  return isDate(from) && isDate(to) && isSameDayOrAfter(Date.now(), from) && isAfter(from, to);
};
var travelDaysBetween = function travelDaysBetween(start, end) {
  return differenceInCalendarDays(start, end) + 1;
};
var formatISODate = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
  representation: 'date'
});
var formatISODateTime = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, "yyyy-MM-dd'T'HH:mm");
var formatClientDate = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, 'dd.MM.yyyy');
var formatYMDDate = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, 'yyyyMMdd');
var formatReadableDate = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
}, "eeeeee'.' dd MMM"); // ti. 16 nov.

var formatReadableDateShort = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
}, "eeeeee'.' dd.MM"); // ti. 16.11

var formatReadableDateShortNoWeekday = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
}, 'dd. MMM'); // 16. nov

var formatReadableDateFull = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
}, "eeee dd'.' MMMM yyyy"); // tirsdag 16. november 2021

var formatReadableDayTime = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
}, "eee'.' HH:mm"); // tir. 15:00

var formatReadableTime = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
}, 'HH:mm'); // date-fns return 'Invalid Date' when passed weird data

var safeFormatClientDate = function safeFormatClientDate(date) {
  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return isDate(date) ? formatClientDate(date) : otherwise;
};
var safeFormatISODate = function safeFormatISODate(date) {
  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return isDate(date) ? formatISODate(date) : otherwise;
};
var safeFormatReadableDate = function safeFormatReadableDate(date) {
  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return isDate(date) ? formatReadableDate(date) : otherwise;
};
var safeParseClientDate = function safeParseClientDate(str) {
  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  try {
    var _date = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new Date(), 'dd.MM.yyyy', str);

    return (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_date) ? _date : otherwise;
  } catch (e) {
    return otherwise;
  }
};
var safeParseISO = function safeParseISO(str) {
  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  try {
    var _date2 = (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(str);

    return (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_date2) ? _date2 : otherwise;
  } catch (e) {
    return otherwise;
  }
};
var safeToDate = function safeToDate(value) {
  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  try {
    var _date3 = toDate(value);

    return isValid(_date3) ? _date3 : otherwise;
  } catch (e) {
    return otherwise;
  }
};
var safeDifferenceInCalendarDays = function safeDifferenceInCalendarDays(other, date) {
  return isDate(other) && isDate(date) ? (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(other, date) : undefined;
}; // Accepts and returns (ISO) dates as strings

var addDaysString = function addDaysString(days, date) {
  return formatISODate(addDays(days, parseISO(date)));
};
var subDaysString = function subDaysString(days, date) {
  return formatISODate(subDays(days, parseISO(date)));
}; // Test helpers

var dayOfNextMonth = function dayOfNextMonth(day) {
  return addDays(day - 1, setDate(1, addMonths(1, Date.now())));
};
var addDaysClient = function addDaysClient(days) {
  return formatClientDate(addDays(days, new Date()));
};
var addDaysServer = function addDaysServer(days) {
  return formatISODate(addDays(days, new Date()));
};

/***/ }),

/***/ 6235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IK": function() { return /* binding */ thousandSeparated; },
/* harmony export */   "SL": function() { return /* binding */ setNumberOfDecimals; }
/* harmony export */ });
/* unused harmony exports validSeoPath, formatDuration */
var thousandSeparated = function thousandSeparated(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
var setNumberOfDecimals = function setNumberOfDecimals(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return (Math.round(value * 100) / 100).toLocaleString('no', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: false
  });
};
/* eslint-disable no-misleading-character-class */

var validSeoPath = function validSeoPath(str) {
  return str.normalize('NFD') // decomposes combined graphemes
  .replace(/[.,'\u0300-\u036f]/g, '') // remove dots, commas, apostrophes and diacritics
  .replace(/\s/gm, '+') // replace spaces
  .replace(/\//g, '+') // replace slashes
  .replace(/[Ææ]/g, 'ae') // replace ÆØÅ
  .replace(/[Øø]/g, 'o').replace(/[Åå]/g, 'a').replace(/[Łł]/g, 'l') // replace weird polish L
  .toLowerCase();
};
/* eslint-enable no-misleading-character-class */

var formatDuration = function formatDuration(totalMinutes) {
  var minutesSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof totalMinutes !== 'number' || isNaN(totalMinutes)) {
    return '-';
  }

  var hours = Math.floor(totalMinutes / 60);
  var minutes = totalMinutes % 60;

  if (minutes < 10) {
    minutes = "0".concat(minutes);
  }

  if (minutesSuffix && hours === 0) {
    return "".concat(minutes, "m");
  }

  return "".concat(hours, "t ").concat(minutes).concat(minutesSuffix ? 'm' : '');
};

/***/ }),

/***/ 5853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lx": function() { return /* binding */ initialBannerPublishEvent; },
/* harmony export */   "fK": function() { return /* binding */ filterBannerPublishEvent; }
/* harmony export */ });
/* unused harmony export bannerPodletPublishEvent */
/* harmony import */ var _podium_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4979);

var messageBus;

var lookupMessageBus = function lookupMessageBus() {
  if (!messageBus) {
    messageBus = new _podium_browser__WEBPACK_IMPORTED_MODULE_0__/* .MessageBus */ .Y();
  }

  return messageBus;
};

var initialBannerPublishEvent = function initialBannerPublishEvent(_ref) {
  var pageType = _ref.pageType,
      page = _ref.page,
      city = _ref.city,
      country = _ref.country;
  return bannerPodletPublishEvent({
    type: 'page',
    action: 'loaded',
    pageType: pageType,
    page: page,
    city: city,
    country: country
  });
};
var filterBannerPublishEvent = function filterBannerPublishEvent(_ref2) {
  var page = _ref2.page,
      city = _ref2.city,
      country = _ref2.country;
  return bannerPodletPublishEvent({
    type: 'filter',
    action: 'updated',
    page: page,
    city: city,
    country: country
  });
};
var bannerPodletPublishEvent = function bannerPodletPublishEvent(_ref3) {
  var type = _ref3.type,
      action = _ref3.action,
      pageType = _ref3.pageType,
      page = _ref3.page,
      city = _ref3.city,
      country = _ref3.country;

  try {
    var data = {
      pageType: pageType,
      side: page || 1,
      destinasjon: {
        by: city || '',
        land: country || ''
      }
    };

    if (!pageType) {
      delete data.pageType;
    }

    lookupMessageBus().publish(type, action, data);
  } catch (e) {
    // Errors thrown here are out of our control, so we simply swallow them
    if (false) {}
  }
};

/***/ })

}]);